// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".largeUnitDisplay {\n  border-radius: 8px;\n  font-size: 1rem;\n  width: 8.5rem;\n  height: 5rem;\n  color: white;\n}\n\n.largeUnitDisplay:hover {\n  transition: box-shadow 0.3s;\n  box-shadow: 2px 2px 3px 3px rgb(0 0 0 / 62%);\n}\n\n\n", ""]);
// Exports
module.exports = exports;
